<template>
  <div class="wrapper" v-html="template">
  </div>
</template>

<script>
import _ from 'underscore';

export default {
  name: 'DynamicDataView',
  props: ["html","data"],
  data() {
    return {
      functemp: false,
      template: '',
    }
  },
  watch: {
    data() {
      if (this.functemp) {
        this.updateTemplate();
      }
    },
    html() {
      console.log('html update');
      console.log(JSON.stringify(this.data));
      try {
        this.functemp = _.template(this.html);
        this.updateTemplate();
      } catch (err) {
        console.warn(err);
      }
    }
  },
  methods: {
    updateTemplate() {
      try {
        this.template = this.functemp(this.data);
      } catch (err) {
        console.warn(err);
      }
    }
  }
}
</script>
